import Head from 'components/Head'
import Banner from 'components/pages/Realiza/Banner'
import Proposito from 'components/pages/Realiza/Proposito'
import Vocacao from 'components/pages/Realiza/Vocacao'
import MissaoCompromisso from 'components/pages/Realiza/MissaoCompromisso'
import SectionHighlights from 'components/Highlights'
import ReceiveNews from 'components/ReceiveNews'


export default function Realiza({ data }) {
  return (
    <>
      <Head data={data.seo} />
      <Banner data={data.banner} />
      <Proposito data={data.proposito} />
      <Vocacao data={data.vocacao} />
      <MissaoCompromisso data={data.missaoCompromisso} />
      <SectionHighlights data={data.secaoDestaques}/>
      <ReceiveNews data={data.secaoRecebaNovidades}/>
    </>
  )
}